/**
 * A directive for adding google places autocomplete to a text box
 * google places autocomplete info: https://developers.google.com/maps/documentation/javascript/places
 *
 * Usage:
 *
 * + ng-model - autocomplete textbox value
 *
 * + details - more detailed autocomplete result, includes address parts, latlng, etc. (Optional)
 *
 * + options - configuration for the autocomplete (Optional)
 *
 *       + types: type,        String, values can be 'geocode', 'establishment', '(regions)', or '(cities)'
 *       + bounds: bounds,     Google maps LatLngBounds Object, biases results to bounds, but may return results outside these bounds
 *       + country: country    String, ISO 3166-1 Alpha-2 compatible country code. examples; 'ca', 'us', 'gb'
 *       + watchEnter:         Boolean, true; on Enter select top autocomplete result. false(default); enter ends autocomplete
 *
 * example:
 *
 *    options = {
 *        types: '(cities)',
 *        country: 'ca'
 *    }
 * */

angular.module('main').directive('ngAutocomplete', () => ({
	require: 'ngModel',
	scope: {
		ngModel: '=',
		options: '=?',
		details: '=?'
	},

	link(scope, element, attrs, controller) {
		let opts;
		let watchEnter = true;
		let foundLocation = '';

		// function to get retrieve the autocompletes first result using the AutocompleteService
		const getPlace = function(result) {
			const autocompleteService = new google.maps.places.AutocompleteService();
			if (result.name.length > 0) {
				autocompleteService.getPlacePredictions(
					{
						input: result.name,
						offset: result.name.length
					},
					(list, status) => {
						if (list === null || list.length === 0) {
							scope.$apply(() => {
								scope.details = null;
							});
						} else {
							const placesService = new google.maps.places.PlacesService(
								element[0]
							);

							placesService.getDetails(
								{
									reference: list[0].reference,
									fields: ['formatted_address', 'name']
								},
								(detailsResult, placesServiceStatus) => {
									if (placesServiceStatus === google.maps.GeocoderStatus.OK) {
										scope.$apply(() => {
											let formattedAddress;
											if (
												detailsResult.formatted_address.includes(
													detailsResult.name
												)
											) {
												formattedAddress = detailsResult.formatted_address;
											} else {
												formattedAddress = `${detailsResult.name}, ${
													detailsResult.formatted_address
												}`;
											}

											controller.$setViewValue(formattedAddress);

											element.val(formattedAddress);

											scope.details = detailsResult;

											// on focusout the value reverts, need to set it again.
											const watchFocusOut = element.on('focusout', event => {
												element.val(formattedAddress);
												element.unbind('focusout');
											});
										});
									}
								}
							);
						}
					}
				);
			}
		};

		const initOpts = function() {
			opts = {};
			if (scope.options) {
				if (scope.options.foundLocation) {
					foundLocation = scope.options.foundLocation;
				} else {
					foundLocation = '';
				}

				watchEnter = scope.options.watchEnter === true;

				if (scope.options.types) {
					opts.types = [];
					opts.types.push(scope.options.types);
					scope.gPlace.setTypes(opts.types);
				} else {
					scope.gPlace.setTypes([]);
				}

				if (scope.options.bounds) {
					opts.bounds = scope.options.bounds;
					scope.gPlace.setBounds(opts.bounds);
				} else {
					scope.gPlace.setBounds(null);
				}

				if (scope.options.country) {
					opts.componentRestrictions = {
						country: scope.options.country
					};
					scope.gPlace.setComponentRestrictions(opts.componentRestrictions);
				} else {
					scope.gPlace.setComponentRestrictions(null);
				}
			}
		};

		if (!google) {
			const newError = new Error("Google didn't loaded!");
			newError();
			return false;
			/*
            	eslint no-new: "error"
            */
		}

		if (typeof scope.gPlace === 'undefined') {
			scope.gPlace = new google.maps.places.Autocomplete(element[0], {
				fields: ['address_components', 'formatted_address', 'name']
			});
		}
		google.maps.event.addListener(scope.gPlace, 'place_changed', () => {
			const result = scope.gPlace.getPlace();

			if (result !== undefined) {
				if (result.address_components !== undefined) {
					scope.$apply(() => {
						scope.details = result;
						controller.$setViewValue(element.val());
					});
				} else if (watchEnter) {
					getPlace(result);
				}
			}
		});

		controller.$render = function() {
			const location = controller.$viewValue;
			element.val(location);
		};

		// watch options provided to directive
		scope.watchOptions = function() {
			return scope.options;
		};
		scope.$watch(
			scope.watchOptions,
			() => {
				initOpts();
			},
			true
		);
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Elements/angularGoogleAutocomplete.js